export default {
    "MIME-Version": "1.0",
    "Content-Type": "text/plain; charset=utf-8",
    "Content-Transfer-Encoding": "8bit",
    "X-Generator": "Ideo Core",
    "Language": "en-US",
    "Messages": {
        "3": "3",
        "5": "5",
        "10": "10",
        " Elementy do uzupełnienia w tekście zamieszczamy pomiędzy zdefiniowanymi znacznikami %$dowolna_nazwa$%.": " Fill-in-text items are placed between defined markers %$any_name$%.",
        " godz.": " hr.",
        " opublikowanych": " published",
        " użytkowników.": " users.",
        "-": "-",
        "%$ – znacznik otwierający tag": "%$ – tag opening marker",
        "%0": "%0",
        "${item.name}": "${item.name}",
        "$% - znacznik zamykający tag": "$% - tag closing marker",
        "Aby dodawać członków zespołu musisz najpierw zapisać formularz.": "To add team members, you must first save form.",
        "Aby dodawać stanowiska musisz najpierw zapisać formularz.": "To add positions, you must first save form.",
        "Aby dodawać użytkowników do szkolenia musisz najpierw zapisać formularz.": "To add users to training, you must first save form.",
        "Aby dodawać użytkowników do ścieżki szkoleniowej musisz najpierw zapisać formularz.": "To add users to training path, you must first save form.",
        "Aby dodawać użytkowników do terminu musisz najpierw zapisać formularz.": "To add users to session, you must first save form.",
        "Aby dodawać wydziały musisz najpierw zapisać formularz.": "To add departments, you must first save form.",
        "Aby dodawać zespół do szkolenia musisz najpierw zapisać formularz.": "To add team to training, you must first save form.",
        "Aby dodawać zespół do ścieżki szkoleniowej musisz najpierw zapisać formularz.": "To add team to training path, you must first save form.",
        "Aby móc zapisać element szkolenia, powinien on posiadać przynajmniej jeden opublikowany slajd.": "To save training item, it should have at least one published slide.",
        "Aby zobaczyć aktualny podgląd certyfikatu kliknij Zapisz.": "To see current certificate preview, click Save.",
        "Adres strony": "Page address",
        "Adres URL Webinaru": "Webinar URL",
        "Adresy email": "Email addresses",
        "Akceptuj": "Accept",
        "Akcja zakończona niepowodzeniem dla: ": "Action failed for: ",
        "Akcje": "Actions",
        "Aktualizacja wyników szkolenia użytkowników została dodana do kolejki zadań.": "Update of user training results has been added to task queue.",
        "Aktualny": "Current",
        "Aktywne": "Active",
        "Aktywność": "Activity",
        "Angielski": "English",
        "Ankieta po szkoleniu": "Post-training survey",
        "Ankieta przed szkoleniem": "Pre-training survey",
        "Anuluj": "Cancel",
        "Anuluj wszystkie wprowadzone zmiany": "Cancel all entered changes",
        "Aranżacja domyślna": "Default arrangement",
        "Aranżacja została dodana.": "Arrangement has been added.",
        "Aranżacja została zaktualizowana.": "Arrangement has been updated.",
        "Archiwalne elementy szkolenia": "Archived training items",
        "Archiwizuj": "Archive",
        "Archiwizuj materiał lekcji": "Archive lesson material",
        "Archiwizuj materiał testu": "Archive test material",
        "Archiwizuj stronę": "Archive page",
        "Archiwum": "Archive",
        "Audio": "Audio",
        "Audio z biblioteki": "Audio from library",
        "Autor": "Author",
        "Autor spotkania": "Meeting author",
        "Autor szkolenia": "Training author",
        "Biały": "White",
        "Biblioteka": "Library",
        "Bloki": "Blocks",
        "Blokowanie użytkowników": "Blocking users",
        "Blokowanie użytkowników szkoleń": "Blocking training users",
        "Błędnie określona liczba, sprawdź liczbę opublikowanych materiałów.": "Incorrectly specified number, check number of published materials.",
        "Błędny format adresu e-mail": "Invalid email address format",
        "brak": "none",
        "Brak": "None",
        "Brak dostępu do szkoleń": "No access to training",
        "Brak kategorii": "No category",
        "Brak kategorii nadrzędnej": "No parent category",
        "Brak kluczy": "No keys",
        "Brak możliwości zmiany spotkania po utworzeniu terminu.": "Meeting cannot be changed after session is created.",
        "Brak opisu": "No description",
        "Brak tematu": "No subject",
        "Brak typu zadania": "No task type",
        "Brak uprawnień do zaliczania elementów.": "No privileges to complete items.",
        "Brak wyników": "No results",
        "Certyfikat": "Certificate",
        "Certyfikat jest opublikowany": "Certificate is published",
        "Certyfikat nie jest opublikowany": "Certificate is not published",
        "Certyfikat przygotowany jest do formatu A4. Wyświetlany podgląd stanowi jedynie widok roboczy. Docelowy wygląd certyfikatu będzie powiązany z właściwymi danymi szkolenia oraz użytkownika.": "Certificate is prepared for A4 format. Displayed preview is only working view. Final certificate appearance will be linked to correct training and user data.",
        "Certyfikat został dodany.": "Certificate has been added.",
        "Certyfikat został usunięty.": "Certificate has been deleted.",
        "Certyfikat został zaktualizowany.": "Certificate has been updated.",
        "Certyfikat-podgląd": "Certificate-preview",
        "Certyfikatów": "Certificates",
        "Certyfikaty": "Certificates",
        "Chat": "Chat",
        "Chat z raportami szkoleń": "Chat with training reports",
        "Chcesz przywrócić temat wraz z elementami?": "Do you want to restore subject together with items?",
        "Chcesz przywrócić ten element?": "Do you want to restore this item?",
        "Cykliczne": "Recurring",
        "Cykliczność": "Recurrence",
        "Cytat": "Quote",
        "Cytaty": "Quotes",
        "Czarny": "Black",
        "Czas": "Time",
        "Czas dostępu do szkolenia (liczba dni)": "Training access time (number of days)",
        "Czas dostępu do ścieżki (liczba dni)": "Path access time (number of days)",
        "Czas na realizację szkolenia (liczba dni)": "Time to complete training (number of days)",
        "Czas na realizację ścieżki (liczba dni)": "Time to complete path (number of days)",
        "Czas trwania": "Duration",
        "Czas ważności certyfikatu (liczba dni)": "Certificate validity period (number of days)",
        "czerwcu": "in June",
        "czerwiec": "June",
        "Czerwony": "Red",
        "Członkowie zespołu": "Team members",
        "Czwartek": "Thursday",
        "Czy na pewno chcesz ukryć wiadomość?": "Are you sure you want to hide message?",
        "Czy na pewno chcesz zablokować użytkownika?": "Are you sure you want to block user?",
        "Czy na pewno chcesz zkopiować szkolenie?": "Are you sure you want to copy training?",
        "Czy opublikowany": "Whether published",
        "Czy zablokować użytkownika i jego wiadomości?": "Block user and user messages?",
        "Dashboard": "Dashboard",
        "Dashboard szkolenia": "Training dashboard",
        "Data": "Date",
        "Data do": "Date to",
        "Data dodania": "Date added",
        "Data logowania": "Login date",
        "Data modyfikacji": "Modification date",
        "Data od": "Date from",
        "Data opuszczenia zespołu": "Date of leaving team",
        "Data ostatniej aktualizacji danych": "Date of last data update",
        "Data ostatniej edycji": "Date of last edit",
        "Data otrzymania punktów": "Date points received",
        "Data otrzymania punktów do": "Date points received to",
        "Data otrzymania punktów od": "Date points received from",
        "Data publikacji": "Publication date",
        "Data rozpoczęcia": "Start date",
        "Data rozpoczęcia spotkania od": "Meeting start date from",
        "Data utworzenia": "Creation date",
        "Data uzyskania certyfikatu": "Certificate obtained date",
        "Data uzyskania do": "Date obtained to",
        "Data uzyskania od": "Date obtained from",
        "Data zakończenia": "End date",
        "Data zakończenia zapisów do": "Enrollment end date to",
        "Data zakończenia zapisów od": "Enrollment end date from",
        "Data zakończenia zapisów: ": "Enrollment end date: ",
        "Data zakónczenia spotkania do": "Meeting end date to",
        "Data zaliczenia": "Completion date",
        "Data zapisu": "Enrollment date",
        "Daty dostępów dla użytkowników ze ścieżki szkoleniowej są nadrzędne, daty dostępów dodane w szkoleniu nie będą brane pod uwagę.": "Access dates for users from training path are overriding, access dates added in training will not be taken into account.",
        "Długi tekst": "Long text",
        "Długość treści": "Content length",
        "Do akceptacji": "For approval",
        "Do szkolenia nie przypisano jeszcze żadnych użytkowników.": "No users have been assigned to training yet.",
        "Do szkolenia nie przypisano jeszcze żadnych zespołów.": "No teams have been assigned to training yet.",
        "Do ścieżki szkoleniowej nie przypisano jeszcze żadnych użytkowników.": "No users have been assigned to training path yet.",
        "Do ścieżki szkoleniowej nie przypisano jeszcze żadnych zespołów.": "No teams have been assigned to training path yet.",
        "Do terminu nie przypisano jeszcze żadnych użytkowników.": "No users have been assigned to session yet.",
        "Dodaj": "Add",
        "Dodaj certyfikat": "Add certificate",
        "Dodaj do zespołu": "Add to team",
        "Dodaj element": "Add item",
        "Dodaj kafelek": "Add tile",
        "Dodaj kategorie": "Add categories",
        "Dodaj kategorię": "Add category",
        "Dodaj lekcję": "Add lesson",
        "Dodaj lekcję SCORM": "Add SCORM lesson",
        "Dodaj lekcję Wideo": "Add video lesson",
        "Dodaj link": "Add link",
        "Dodaj mp3": "Add mp3",
        "Dodaj nową opinie": "Add new review",
        "Dodaj obrazek": "Add image",
        "Dodaj odpowiedź": "Add answer",
        "Dodaj odznakę": "Add badge",
        "Dodaj paczkę SCORM": "Add SCORM package",
        "Dodaj punkty": "Add points",
        "Dodaj pytanie": "Add question",
        "Dodaj slajd": "Add slide",
        "Dodaj spotkanie": "Add meeting",
        "Dodaj stwierdzenie": "Add statement",
        "Dodaj szkolenie": "Add training",
        "Dodaj ścieżkę": "Add path",
        "Dodaj temat": "Add subject",
        "Dodaj termin": "Add session",
        "Dodaj test": "Add test",
        "Dodaj tylko pracowników z wybranych wydziałów": "Add only employees from selected departments",
        "Dodaj użytkownika": "Add user",
        "Dodaj wiersz": "Add row",
        "Dodaj wszystkie z kategorii": "Add all from category",
        "Dodaj zespół": "Add team",
        "Dodanie certyfikatu": "Adding certificate",
        "Dodanie kategorii": "Adding category",
        "Dodanie lekcji": "Adding lesson",
        "Dodanie paczki SCORM": "Adding SCORM package",
        "Dodanie slajdów": "Adding slides",
        "Dodanie spotkania": "Adding meeting",
        "Dodanie szkolenia": "Adding training",
        "Dodanie ścieżki szkoleniowej": "Adding training path",
        "Dodanie terminu": "Adding session",
        "Dodanie testu": "Adding test",
        "Dodatkowe uwagi": "Additional notes",
        "Dodawanie odznaki": "Adding badge",
        "Dodawanie punktów": "Adding points",
        "Dokument nie jest jeszcze nigdzie opublikowany.": "Document is not published anywhere yet.",
        "Dopasowanie": "Match",
        "Dopasuj do kategorii": "Match to category",
        "Dopasuj do obrazka": "Match to image",
        "Dostęp do": "Access to",
        "Dostęp do terminu": "Access to session",
        "dostęp indywidualny": "individual access",
        "Dostęp od": "Access from",
        "Dostęp przyznany przez zespół": "Access granted by team",
        "Dostęp przyznany ręcznie": "Access granted manually",
        "dostęp z zespołu": "access from team",
        "Dostępne są tylko wydarzenia, które mają włączoną opcję \"Wydarzenie dostępne tylko w module spotkań\"": "Only events with option \"Event available only in meetings module\" enabled are available",
        "Dostępy": "Access",
        "Działania masowe": "Bulk actions",
        "E-learning": "E-learning",
        "E-mail": "E-mail",
        "Edycja certyfikatu": "Edit certificate",
        "Edycja jest obecnie niedostępna, ponieważ trwa proces przetwarzania danych związanych z terminami szkoleń": "Edit is currently unavailable because data processing related to training sessions is in progress",
        "Edycja kategorii": "Edit category",
        "Edycja lekcji": "Edit lesson",
        "Edycja odznaki": "Edit badge",
        "Edycja paczek SCORM": "Edit SCORM packages",
        "Edycja punktów": "Edit points",
        "Edycja slajdów": "Edit slides",
        "Edycja spotkania": "Edit meeting",
        "Edycja szkolenia": "Edit training",
        "Edycja ścieżki szkoleniowej": "Edit training path",
        "Edycja terminu": "Edit session",
        "Edycja testu": "Edit test",
        "Edytuj": "Edit",
        "Edytuj członka grupy": "Edit group member",
        "Edytuj datę dostępu": "Edit access date",
        "Edytuj kategorie": "Edit categories",
        "Edytuj lekcje": "Edit lessons",
        "Edytuj lekcje SCORM": "Edit SCORM lessons",
        "Edytuj lekcje wideo": "Edit video lessons",
        "Edytuj link": "Edit link",
        "Edytuj temat": "Edit subject",
        "Edytuj test": "Edit test",
        "Edytuj użytkownika": "Edit user",
        "Edytuj wpis": "Edit entry",
        "Eksport do Excela": "Export to Excel",
        "element": "item",
        "Element": "Item",
        "Element grupujący": "Grouping item",
        "Element jest wymagany": "Item is required",
        "element niewymagany": "optional item",
        "Element opublikowany": "Published item",
        "Element szkolenia rozpoczęty przez użytkowników": "Training item started by users",
        "Element szkolenia ukończony przez użytkowników": "Training item completed by users",
        "element wymagany": "required item",
        "Element wymagany": "Required item",
        "Element został dodany.": "Item has been added.",
        "Element został przywrócony.": "Item has been restored.",
        "Element został zaktualizowany.": "Item has been updated.",
        "elementów": "items",
        "elementy": "items",
        "Elementy": "Items",
        "Elementy szkolenia": "Training items",
        "Elementy szkolenia użytkownika": "User training items",
        "Elementy szkolenia użytkownika: ${selectedUserData}": "User training items: ${selectedUserData}",
        "Email": "Email",
        "Filtry": "Filters",
        "Formularz": "Form",
        "Generator linku": "Link generator",
        "Generuj nowy link": "Generate new link",
        "Generuj treść slajdu": "Generate slide content",
        "grudniu": "in December",
        "grudzień": "December",
        "Grywalizacja": "Gamification",
        "Historia wygenerowanych treści.": "History of generated content.",
        "ID": "ID",
        "Ikona": "Icon",
        "Imię": "First name",
        "Imię i nazwisko": "First and last name",
        "Imię i Nazwisko": "First and Last Name",
        "Import slajdów z PDF": "Import slides from PDF",
        "Importuj": "Import",
        "Importuj slajdy": "Import slides",
        "Informacje dodatkowe": "Additional information",
        "Jasny niebieski": "Light blue",
        "Jednokrotnego wyboru": "Single choice",
        "Jeszcze nie ma kategorii.": "There are no categories yet.",
        "Język": "Language",
        "Katalog linków": "Link catalog",
        "Kategoria": "Category",
        "Kategoria materiałów": "Material category",
        "Kategoria materiału": "Material category",
        "Kategoria nadrzędna": "Parent category",
        "Kategoria slajdu": "Slide category",
        "Kategoria spotkania": "Meeting category",
        "Kategoria szkolenia": "Training category",
        "Kategoria wyszukiwanego materiału": "Searched material category",
        "Kategoria została dodana.": "Category has been added.",
        "Kategoria została usunięta.": "Category has been deleted.",
        "Kategoria została zaktualizowana.": "Category has been updated.",
        "Kategoria: ": "Category: ",
        "Kategorie": "Categories",
        "Kategorie materiałów": "Material categories",
        "Kategorie spotkań": "Meeting categories",
        "Kategorie szkoleń": "Training categories",
        "Klucze": "Keys",
        "Kobieta": "Female",
        "Kolejność zaliczania elementów": "Order of completing items",
        "Kolor tła": "Background color",
        "Komunikat po niezaliczeniu testu": "Message after failing test",
        "Komunikat po otrzymaniu odznaki": "Message after receiving badge",
        "Komunikat po zaliczeniu testu": "Message after passing test",
        "Konfiguracja": "Configuration",
        "Konto aktywne": "Active account",
        "Koordynator": "Coordinator",
        "Koordynatorów": "Coordinators",
        "Koordynowane szkolenia:": "Coordinated training:",
        "Kopiuj pole": "Copy field",
        "Kreator szkoleń": "Training wizard",
        "Kreator Szkoleń AI": "AI Training Wizard",
        "Krótki opis": "Short description",
        "Krótki tekst": "Short text",
        "kwiecień": "April",
        "kwietniu": "in April",
        "Legenda": "Legend",
        "Lekcja": "Lesson",
        "Lekcja do powtórzenia": "Lesson to repeat",
        "Lekcja może zawierać tylko materiały opisowe": "Lesson can contain only descriptive materials",
        "Lekcja może zawierać tylko materiały opisowe lub materiały video": "Lesson can contain only descriptive materials or video materials",
        "Lekcja SCORM ukryta": "Hidden SCORM lesson",
        "Lekcja SCORM została dodana.": "SCORM lesson has been added.",
        "Lekcja SCORM została zaktualizowana.": "SCORM lesson has been updated.",
        "Lekcja ukryta": "Hidden lesson",
        "Lekcja wideo została dodana.": "Video lesson has been added.",
        "Lekcja wideo została zaktualizowana.": "Video lesson has been updated.",
        "Lekcja została dodana.": "Lesson has been added.",
        "Lekcja została zaktualizowana.": "Lesson has been updated.",
        "Lekcje": "Lessons",
        "Lekcje video": "Video lessons",
        "Liczba dni co ile wysyłane jest powiadomienie": "Number of days after which notification is sent",
        "Liczba dni do zakończenia szkolenia przy której zostanie wysłane powiadomienie": "Number of days before training end when notification will be sent",
        "Liczba dni od jakiej użytkownik otrzyma powiadomienie": "Number of days from which user will receive notification",
        "Liczba elementów": "Number of items",
        "Liczba elementów do uzupełnienia": "Number of fill-in items",
        "Liczba kategorii": "Number of categories",
        "Liczba koordynatorów": "Number of coordinators",
        "Liczba koordynowanych szkoleń: %0": "Number of coordinated training: %0",
        "Liczba miejsc": "Number of seats",
        "Liczba odpowiedzi": "Number of answers",
        "Liczba opublikowanych elementów (zakładka Zawartość) musi być większa lub równa ustawionej liczbie wyświetlanych elementów (zakładka Ustawienia)": "Number of published items (Content tab) must be greater than or equal to set number of displayed items (Settings tab)",
        "Liczba podejść": "Number of attempts",
        "Liczba podejść nie może być mniejsza niż 0": "Number of attempts cannot be less than 0",
        "Liczba powtórzeń": "Number of repetitions",
        "Liczba punktów": "Number of points",
        "Liczba punktów nie może być liczbą ujemną": "Number of points cannot be negative",
        "Liczba pytań": "Number of questions",
        "Liczba spotkań": "Number of meetings",
        "Liczba szkoleń": "Number of training",
        "Liczba szkoleń w ścieżce": "Number of training in path",
        "Liczba uczestników": "Number of participants",
        "Liczba użytkowników": "Number of users",
        "Liczba użytkowników szkolenia": "Number of training users",
        "Liczba wyświetlanych elementów": "Number of displayed items",
        "Liczba zapisanych": "Number of enrolled",
        "Liczba zapisanych osób": "Number of enrolled people",
        "Liczba zapisanych/Liczba dostępnych miejsc: ": "Number enrolled/Number of available seats: ",
        "Lider": "Leader",
        "Limit czasu (minuty)": "Time limit (minutes)",
        "Limit czasu nie może być mniejszy niż 0 minut": "Time limit cannot be less than 0 minutes",
        "Limit miejsc": "Seat limit",
        "Linia ciągła": "Solid line",
        "Linia falująca": "Wavy line",
        "Linia kreskowana": "Dashed line",
        "Linia kropkowana": "Dotted line",
        "Link": "Link",
        "Link do strony": "Link to page",
        "Link do wybranej strony serwisu": "Link to selected service page",
        "Link do zewnętrznej strony": "Link to external page",
        "Link przycisku": "Button link",
        "Link został dodany.": "Link has been added.",
        "Link został skopiowany.": "Link has been copied.",
        "Link został usunięty.": "Link has been deleted.",
        "Link został wygenerowany.": "Link has been generated.",
        "Link został zaktualizowany.": "Link has been updated.",
        "lipcu": "in July",
        "lipiec": "July",
        "Lista": "List",
        "Lista certyfikatów": "Certificate list",
        "Lista elementów": "Item list",
        "Lista jest pusta": "List is empty",
        "Lista koordynatorów": "Coordinator list",
        "Lista paczek SCORM": "SCORM package list",
        "Lista rezerwowa": "Waiting list",
        "Lista spotkań": "Meeting list",
        "Lista szkoleń": "Training list",
        "Lista ścieżek szkoleniowych": "Training path list",
        "Lista uczestników": "Participant list",
        "Lista wyboru": "Dropdown list",
        "Lista zapisanych": "Enrolled list",
        "Lista zespołów": "Team list",
        "listopad": "November",
        "listopadzie": "in November",
        "Log błędu": "Error log",
        "Log z aktywności": "Activity log",
        "Logi aktywności zostały wyczyszczone": "Activity logs have been cleared",
        "Login": "Login",
        "Logo": "Logo",
        "Losowa kolejność elementów": "Random order of items",
        "luty": "February",
        "lutym": "in February",
        "maj": "May",
        "maju": "in May",
        "Maksymalna liczba podejść to 500": "Maximum number of attempts is 500",
        "Maksymalna liczba punktów": "Maximum number of points",
        "Maksymalna limit czasu to 500 minut": "Maximum time limit is 500 minutes",
        "marcu": "in March",
        "marzec": "March",
        "Masz niezapisane zmiany w materiałach. Zapisz je lub usuń aby móc zapisać element szkolenia.": "You have unsaved changes in materials. Save or delete them to be able to save training item.",
        "Materiał opisowy": "Descriptive material",
        "Materiał wideo": "Video material",
        "Materiały szkoleniowe": "Training materials",
        "Max: 250 znaków": "Max: 250 characters",
        "Mężczyzna": "Male",
        "Miniaturka": "Thumbnail",
        "Miniaturka wideo": "Video thumbnail",
        "Minimalny czas oglądania potrzebny do zaliczenia elementu (hh:mm:ss)": "Minimum watch time required to complete item (hh:mm:ss)",
        "Moduły": "Modules",
        "Monitor aktywności": "Activity monitor",
        "Multimedia": "Multimedia",
        "Nadpisz wersję lekcji": "Overwrite lesson version",
        "Nadpisz wersję lekcji scorm": "Overwrite SCORM lesson version",
        "Nadpisz wersję lekcji wideo": "Overwrite video lesson version",
        "Nadpisz wersję linku": "Overwrite link version",
        "Nadpisz wersję testu": "Overwrite test version",
        "Najnowsze": "Newest",
        "Nazwa": "Name",
        "Nazwa aranżacji": "Arrangement name",
        "Nazwa certyfikatu": "Certificate name",
        "Nazwa elementu": "Item name",
        "Nazwa grupy": "Group name",
        "Nazwa kategorii": "Category name",
        "Nazwa koordynatora": "Coordinator name",
        "Nazwa lekcji": "Lesson name",
        "Nazwa odznaki": "Badge name",
        "Nazwa odznaki dla użytkownika": "Badge name for user",
        "Nazwa paczki": "Package name",
        "Nazwa paczki SCORM": "SCORM package name",
        "Nazwa pliku": "File name",
        "Nazwa pokoju": "Room name",
        "Nazwa pola": "Field name",
        "Nazwa przycisku": "Button name",
        "Nazwa slajdu": "Slide name",
        "Nazwa spotkania": "Meeting name",
        "Nazwa spotkania: ": "Meeting name: ",
        "Nazwa szkolenia": "Training name",
        "Nazwa ścieżki": "Path name",
        "Nazwa terminu": "Session name",
        "Nazwa testu": "Test name",
        "Nazwa użytkownika": "User name",
        "Nazwa zespołu": "Team name",
        "Nazwisko": "Last name",
        "nie": "no",
        "Nie": "No",
        "Nie można ustawić dat dostępów dla szkoleń cyklicznych.": "Access dates cannot be set for recurring training.",
        "Nie można usunąć kategorii do ktorej są przypisane elementy.": "Cannot delete category to which items are assigned.",
        "Nie podano": "Not provided",
        "Nie podano nazwy poprzedniego elementu.": "Previous item name was not provided.",
        "Nie podano nazwy poprzedniej kategorii.": "Previous category name was not provided.",
        "Nie podano odpowiedzi dla ostatniego elementu.": "No answer provided for last item.",
        "Nie udało się pobrać listy aranżacji": "Failed to fetch arrangement list",
        "Nie udało się pobrać listy kategorii": "Failed to fetch category list",
        "Nie udało się pobrać listy modułów": "Failed to fetch module list",
        "Nie udało się pobrać listy ról": "Failed to fetch role list",
        "Nie udało się pobrać listy stanowisk": "Failed to fetch position list",
        "Nie udało się pobrać listy stron": "Failed to fetch page list",
        "Nie udało się pobrać listy typów materiałów": "Failed to fetch material type list",
        "Nie udało się pobrać listy wydziałów": "Failed to fetch department list",
        "Nie wybrano ankiety": "No survey selected",
        "Nie wybrano paczki.": "No package selected.",
        "Nie wybrano strony": "No page selected",
        "Nie wybrano użytkownika.": "No user selected.",
        "Nie wybrano żadnego użytkownika.": "No user selected.",
        "Nie wypełniono poprzedniego wiersza.": "Previous row was not filled in.",
        "Nie zdefiniowano żadnych ról.": "No roles have been defined.",
        "Nie znaleziono elementu.": "Item not found.",
        "Nie znaleziono żadnych linków.": "No links found.",
        "Nie znaleziono żadnych szkoleń dla tego zespołu.": "No training found for this team.",
        "Nie znaleziono żadnych użytkowników.": "No users found.",
        "Nie znaleziono żadnych wyników.": "No results found.",
        "Niebieski": "Blue",
        "Niedziela": "Sunday",
        "Nieobecny": "Absent",
        "Nieopublikowane": "Unpublished",
        "Nierozpoczęli": "Did not start",
        "Nierozpoczęty": "Not started",
        "Niezaliczenie testu jest równoznaczne z potwierdzeniem obecności użytkownika": "Failing test is equivalent to confirming user attendance",
        "Niezaliczone": "Not completed",
        "Niezaliczony": "Not completed",
        "Niezaliczyło": "Did not complete",
        "Niżej": "Below",
        "Nowe połączenie": "New connection",
        "Nowy materiał": "New material",
        "O szkoleniu": "About training",
        "Obecność": "Attendance",
        "Obecność została potwierdzona.": "Attendance has been confirmed.",
        "Obecny": "Present",
        "Obrazek": "Image",
        "Obrazek wyróżniający": "Featured image",
        "Obsługa progu przez platformę": "Threshold handling by platform",
        "Ocena offline": "Offline grading",
        "Oczekuje na akceptację": "Pending approval",
        "Odpowiedzi": "Answers",
        "Odpowiedź": "Answer",
        "Odrzucone": "Rejected",
        "Odznaka została dodana.": "Badge has been added.",
        "Odznaka została zaktualizowana.": "Badge has been updated.",
        "Odznaki": "Badges",
        "Ogólne": "General",
        "Opiekun ścieżki": "Path guardian",
        "Opis": "Description",
        "Opis kategorii": "Category description",
        "Opis obrazka": "Image description",
        "Opis spotkania": "Meeting description",
        "Opis szkolenia": "Training description",
        "Opis zespołu": "Team description",
        "Opublikowane": "Published",
        "Opublikowany": "Published",
        "Opublikuj": "Publish",
        "Opublikuj materiał": "Publish material",
        "Opublikuj ścieżkę szkoleniową aby móc dodać szkolenia": "Publish training path to be able to add training",
        "Osoba odpowiedzialna": "Responsible person",
        "Ostatnio aktualizowane": "Recently updated",
        "Ostatnio oglądane": "Recently viewed",
        "Otwórz stronę w nowym oknie": "Open page in new window",
        "Otwórz w nowym oknie": "Open in new window",
        "Oznacz wszystkie elementy szkolenia jako zaliczone": "Mark all training items as completed",
        "Paczka SCORM została dodana.": "SCORM package has been added.",
        "Paczka SCORM została zaktualizowana.": "SCORM package has been updated.",
        "Paczka została usunięta.": "Package has been deleted.",
        "Paczki SCORM": "SCORM packages",
        "październik": "October",
        "październiku": "in October",
        "Piątek": "Friday",
        "Pionowo": "Vertically",
        "Plik PDF": "PDF file",
        "Po dodaniu szkoleń nie można zmienić publikacji.": "After adding training, publication cannot be changed.",
        "Po ustawieniu dat dostępów dla użytkowników w ścieżce będą one nadrzędne, daty dostępów dodane w szkoleniu nie będą brane pod uwagę.": "After setting access dates for users in path, they will be overriding, access dates added in training will not be taken into account.",
        "Po ustawieniu indywidualnych dat dostępów dla użytkowników będą one nadrzędne, daty dostępów z zespołów nie będą brane pod uwagę.": "After setting individual access dates for users, they will be overriding, access dates from teams will not be taken into account.",
        "Pobierz certyfikat": "Download certificate",
        "Podaj uwagi do treści, która ma zostać wygenerowana. Przykład: \"Używaj symboli matematycznych\".": "Enter notes for content to be generated. Example: \"Use mathematical symbols\".",
        "Podany adres e-mail został już dodany": "Provided email address has already been added",
        "Podejście do elementu zostało zresetowane.": "Attempt for item has been reset.",
        "Podgląd": "Preview",
        "Podlega ocenie": "Subject to grading",
        "Podpis": "Signature",
        "Podstawowe": "Basic",
        "Podstawowy": "Basic",
        "Podtytuł": "Subtitle",
        "Podwójna linia ciągła": "Double solid line",
        "Pojedyńcza, prosta, ciągła linia": "Single, straight, solid line",
        "Pola takie jak \"Nazwa slajdu\", \"Kategoria materiału\", \"Typ materiału\" są uwzględniane przy automatycznym generowaniu treści, dlatego konieczne jest ich wypełnienie.": "Fields such as \"Slide name\", \"Material category\", \"Material type\" are included in automatic content generation, so filling them in is required.",
        "Pole skopiowane": "Field copied",
        "Polski": "Polish",
        "Połącz w pary": "Match pairs",
        "Poniedziałek": "Monday",
        "Poprawna odpowiedź": "Correct answer",
        "Posiadasz niezapisane materiały": "You have unsaved materials",
        "Postęp": "Progress",
        "Postęp (%)": "Progress (%)",
        "Postępy": "Progress",
        "Postępy użytkowników": "User progress",
        "Potwierdzenie archiwizacji": "Archive confirmation",
        "Potwierdzenie archiwizacji. Archiwizacja tematu spowoduje zarchiwizowanie przypisanych do niego lekcji": "Archive confirmation. Archiving subject will archive lessons assigned to it",
        "Potwierdzenie przywrócenia szkolenia": "Training restore confirmation",
        "Potwierdzenie publikacji": "Publication confirmation",
        "Potwierdzenie resetu podejścia do elementu szkolenia": "Confirmation of resetting attempt for training item",
        "Potwierdzenie resetu podejścia do szkolenia": "Confirmation of resetting attempt for training",
        "Potwierdzenie ukrycia": "Hide confirmation",
        "Potwierdzenie usunięcia": "Delete confirmation",
        "Potwierdzenie usunięcia.": "Delete confirmation.",
        "Potwierdź akceptację": "Confirm approval",
        "Potwierdź usunięcie": "Confirm deletion",
        "Potwierdź wyczyszczenie logów": "Confirm clearing logs",
        "Potwierdź zapis do aktualnej wersji": "Confirm save to current version",
        "Powiadomienia": "Notifications",
        "Powiadomienia z linkiem rejestracyjnym nie zostaną wysłane, ponieważ ten typ powiadomień nie jest obecnie włączony w platformie.": "Notifications with registration link will not be sent because this notification type is currently not enabled on platform.",
        "Powiadomienie dla administratora chatu o nowych wiadomościach": "Notification for chat administrator about new messages",
        "Powiadomienie dla użytkownika o nowych wiadomościach na chacie": "Notification for user about new messages in chat",
        "Powiadomienie o oczekującym szkoleniu": "Notification about pending training",
        "Powiadomienie o zbliżającym się zakończeniu szkolenia": "Notification about approaching training end",
        "Powiązane stanowiska": "Related positions",
        "Powiązane wydziały": "Related departments",
        "Powód": "Reason",
        "Powrót": "back",
        "Poziomo": "Horizontally",
        "Pozwól kontynuować na obecnej wersji": "Allow continuing on current version",
        "Prawda-Fałsz": "True-False",
        "Produkcyjne": "Production",
        "Profil koordynatora": "Coordinator profile",
        "Program": "Program",
        "Program szkolenia": "Training program",
        "Próg": "Threshold",
        "Próg zaliczenia (%)": "Passing threshold (%)",
        "Przeglądanie logów aktywności": "Viewing activity logs",
        "Przeglądnij logi": "Browse logs",
        "Przenieś niżej": "Move down",
        "Przenieś wyżej": "Move up",
        "przez": "by",
        "Przycisk \"zobacz wszystkie\" znajdujący się przy bloczku, będzie przekierowywał na wybraną stronę z szkoleniami. Jeśli strona nie zostanie wybrana zostanie on ukryty.": "\"View all\" button located next to block will redirect to selected page with training. If page is not selected, it will be hidden.",
        "Przypisz użytkowników do terminu spotkania, aby móc ich wyszukać.": "Assign users to meeting session to be able to search for them.",
        "Przypisz zespoły do terminu spotkania, aby móc je wyszukać.": "Assign teams to meeting session to be able to search for them.",
        "Przywrócić użytkownika i jego wiadomości?": "Restore user and user messages?",
        "Przywrócić wiadomość?": "Restore message?",
        "Przywróć": "Restore",
        "Przywróć użytkownika": "Restore user",
        "Przyznawanie punktów": "Awarding points",
        "Publikacja": "Publication",
        "Publikacja i przypisane szkolenia zostały usunięte.": "Publication and assigned training have been deleted.",
        "Publikacja została dodana.": "Publication has been added.",
        "Publikuj na stronie": "Publish on page",
        "Publikuj spotkanie": "Publish meeting",
        "Publikuj szkolenie": "Publish training",
        "Publikuj ścieżkę szkoleniową": "Publish training path",
        "Publikuj termin": "Publish session",
        "Punkty": "Points",
        "Punkty za ukończenie": "Points for completion",
        "Punkty zostały dodane.": "Points have been added.",
        "Punkty zostały zaktualizowane. Zmiana dotyczy tylko nowo zdobytych punktów.": "Points have been updated. Change applies only to newly earned points.",
        "Pytania i odpowiedzi": "Questions and answers",
        "Pytanie": "Question",
        "Pytanie i odpowiedzi": "Question and answers",
        "Raporty": "Reports",
        "Reset podejścia do szkolenia": "Reset training attempt",
        "Resetowanie podejść": "Resetting attempts",
        "Resetowanie podejść użytkowników": "Resetting user attempts",
        "Resetuj": "Reset",
        "Rezygnacja": "Resignation",
        "Role zespołu": "Team roles",
        "Rozpoczęcie spotkania": "Meeting start",
        "Rozpoczęcie szkolenia": "Training start",
        "Scorm": "Scorm",
        "SCORM": "SCORM",
        "Sekcje dla gości": "Sections for guests",
        "Sekcje dla zalogowanych": "Sections for logged-in users",
        "Sekcje wspólne": "Common sections",
        "Serie kresek lub fragmentów linii": "Series of dashes or line fragments",
        "Serie kropek": "Series of dots",
        "sierpień": "August",
        "sierpniu": "in August",
        "Skopiuj szkolenie": "Copy training",
        "Slajd do powtórzenia": "Slide to repeat",
        "Slajd z materiałów szkoleniowych": "Slide from training materials",
        "Slajd został dodany.": "Slide has been added.",
        "Slajd został usunięty.": "Slide has been deleted.",
        "Slajd został wygenerowany.": "Slide has been generated.",
        "Slajd został zaktualizowany.": "Slide has been updated.",
        "Slajdy": "Slides",
        "Slajdy zostały zaimportowane.": "Slides have been imported.",
        "Sobota": "Saturday",
        "Spotkania": "Meetings",
        "Spotkanie": "Meeting",
        "Spotkanie do": "Meeting to",
        "Spotkanie jest zarchiwizowane.": "Meeting is archived.",
        "Spotkanie od": "Meeting from",
        "Spotkanie zostało dodane.": "Meeting has been added.",
        "Spotkanie zostało usunięte.": "Meeting has been deleted.",
        "Spotkanie zostało zaktualizowane.": "Meeting has been updated.",
        "Sprawdź poprawność wprowadzonych danych. Po zapisaniu kolumna Zaliczenie testu nie będzie edytowalna, ponieważ zostanie wygenerowany certyfikat. Czy zapisać dane?": "Check correctness of entered data. After saving, Test completion column will not be editable because certificate will be generated. Save data?",
        "Stan": "State",
        "Standard": "Standard",
        "Standard 1.2": "Standard 1.2",
        "Standard 2004": "Standard 2004",
        "Standard nieznany": "Unknown standard",
        "Stanowiska": "Positions",
        "Stanowisko": "Position",
        "Stanowisko zostało dodane.": "Position has been added.",
        "Stanowisko zostało usunięte.": "Position has been deleted.",
        "Status": "Status",
        "Status aranżacji został zmieniony.": "Arrangement status has been changed.",
        "Status dokumentu został zmieniony.": "Document status has been changed.",
        "Status paczki został zmieniony.": "Package status has been changed.",
        "Status został zmieniony dla ": "Status has been changed for ",
        "Strona": "Page",
        "Strona %0": "Page %0",
        "Strona lekcji opublikowana": "Lesson page published",
        "Strona lekcji SCORM opublikowana": "SCORM lesson page published",
        "Strona szkolenia ukryta": "Training page hidden",
        "Strona testu opublikowana": "Test page published",
        "Strona została zarchiwizowana.": "Page has been archived.",
        "Stwierdzenia": "Statements",
        "styczeń": "January",
        "styczniu": "in January",
        "Symbol": "Symbol",
        "Symbol lekcji": "Lesson symbol",
        "Symbol może składać się tylko z małych liter, cyfr oraz znaku - ": "Symbol can consist only of lowercase letters, digits, and - sign ",
        "Symbol strony spotkania": "Meeting page symbol",
        "Symbol strony szkolenia": "Training page symbol",
        "Symbol testu": "Test symbol",
        "Synchronizuj": "Synchronize",
        "Szary": "Gray",
        "Szczegóły": "Details",
        "Szczegóły szkolenia": "Training details",
        "Szkic": "draft",
        "szkolenia": "training",
        "Szkolenia": "Training",
        "szkolenie": "training",
        "Szkolenie": "Training",
        "Szkolenie cykliczne": "Recurring training",
        "Szkolenie jest puste": "Training is empty",
        "Szkolenie może występować tylko w jednej ścieżce. To szkolenie zostało już dodane do ścieżki: {0}": "Training can appear only in one path. This training has already been added to path: {0}",
        "Szkolenie w liczbach": "Training in numbers",
        "Szkolenie zostało dodane.": "Training has been added.",
        "Szkolenie zostało przywrócone.": "Training has been restored.",
        "Szkolenie zostało skopiowane": "Training has been copied",
        "Szkolenie zostało zaktualizowane.": "Training has been updated.",
        "Szkolenie zostało zaliczone. Nie można go edytować.": "Training has been completed. It cannot be edited.",
        "Szkolenie zostało zarchiwizowane.": "Training has been archived.",
        "Szkolenie zostało zarchiwizowane. Aby je wyświetlić, należy przywrócić szkolenie z archiwum.": "Training has been archived. To display it, restore training from archive.",
        "Szkoleniowe": "Training",
        "szkoleń": "training",
        "Szkoleń": "Training",
        "Ścieżka": "Path",
        "Ścieżka cykliczna": "Recurring path",
        "Ścieżka już jest opublikowana.": "Path is already published.",
        "Ścieżka szkoleniowa": "Training path",
        "Ścieżka szkoleniowa została dodana.": "Training path has been added.",
        "Ścieżka szkoleniowa została usunięta.": "Training path has been deleted.",
        "Ścieżka szkoleniowa została zaktualizowana.": "Training path has been updated.",
        "Średni tekst": "Medium text",
        "Środa": "Wednesday",
        "Ta aranżacja zostanie użyta jeśli nie przypisano żadnej innej aranżacji do strony.": "This arrangement will be used if no other arrangement has been assigned to page.",
        "tak": "yes",
        "Tak": "Yes",
        "Tekst do uzupełnienia": "Text to fill in",
        "Temat": "Subject",
        "Tematy": "Subjects",
        "Ten element nie zawiera menu kontekstowego.": "This item does not contain context menu.",
        "Ten zespół nie posiada jeszcze żadnych powiązanych stanowisk": "This team does not have any related positions yet",
        "Ten zespół nie posiada jeszcze żadnych powiązanych wydziałów": "This team does not have any related departments yet",
        "Teraz": "Now",
        "Termin posiada test": "Session has test",
        "Termin spotkania: ": "Meeting session: ",
        "Termin został dodany.": "Session has been added.",
        "Termin został usunięty.": "Session has been deleted.",
        "Termin został zaktualizowany.": "Session has been updated.",
        "Terminy": "Sessions",
        "Test": "Test",
        "Test nie może zawierać materiałów opisowych i materiałów video": "Test cannot contain descriptive materials and video materials",
        "Test ukryty": "Hidden test",
        "Test został dodany.": "Test has been added.",
        "Test został zaktualizowany.": "Test has been updated.",
        "Testowe": "Test",
        "Testy": "Tests",
        "Tło certyfikatu": "Certificate background",
        "Tło przycisku": "Button background",
        "Tło strona 2": "Background page 2",
        "To szkolenie znajduje się już w ścieżce szkoleń": "This training is already in training path",
        "Treść": "Content",
        "Treść certyfikatu": "Certificate content",
        "Tryb monitorowania aktywności": "Activity monitoring mode",
        "Tryb monitorowania aktywności włączony.": "Activity monitoring mode enabled.",
        "Tryb monitorowania aktywności wyłączony.": "Activity monitoring mode disabled.",
        "Tylko liderzy": "Leaders only",
        "Typ": "Type",
        "Typ aranżacji": "Arrangement type",
        "Typ elementu": "Item type",
        "Typ linku": "Link type",
        "Typ materiału": "Material type",
        "Typ slajdu": "Slide type",
        "Typ spotkania": "Meeting type",
        "Typy materiałów": "Material types",
        "Tytuł": "Title",
        "Tytuł kafelka": "Tile title",
        "Ukryj": "Hide",
        "Ukryj materiał": "Hide material",
        "Umożliwienie sprawdzania odpowiedzi": "Enable answer checking",
        "Uprawnienia": "Privileges",
        "Uprawnienia do szkolenia pochodzą z terminu spotkań.": "Training privileges come from meeting date.",
        "Uprawnienia użytkownika": "User privileges",
        "Uruchom nagranie automatycznie": "Start recording automatically",
        "Ustaw status": "Set status",
        "Ustaw w kolejności": "Set order",
        "Ustawienia": "Settings",
        "Ustawienia ogólne": "General settings",
        "Ustawienia zostały zaktualizowane.": "Settings have been updated.",
        "Usunięte": "Deleted",
        "Usuń": "Delete",
        "Usuń element": "Delete item",
        "Usuń kafelek": "Delete tile",
        "Usuń kategorię": "Delete category",
        "Usuń nie zapisany materiał z lekcji": "Delete unsaved material from lesson",
        "Usuń nie zapisany materiał z testu": "Delete unsaved material from test",
        "Usuń obrazek": "Delete image",
        "Usuń odpowiedź": "Delete answer",
        "Usuń poprzednie wersje certyfikatu": "Delete previous certificate versions",
        "Usuń pytanie": "Delete question",
        "Usuń stronę": "Delete page",
        "Usuń szkolenie z ścieżki szkoleń": "Delete training from training path",
        "Usuń wiersz": "Delete row",
        "Usuń z terminu": "Delete from date",
        "Usuń ze szkolenia": "Delete from training",
        "Utwórz nowy": "Create new",
        "Uzupełnij dane dotyczące szkolenia": "Complete training details",
        "Uzupełnij luki": "Fill in blanks",
        "Uzupełnij wymagane pola.": "Complete required fields.",
        "Użytkownicy": "Users",
        "Użytkownik": "User",
        "Użytkownik i jego wiadomości zostały przywrócone.": "User and their messages have been restored.",
        "Użytkownik jest liderem zespołu": "User is team leader",
        "Użytkownik nie może się zalogować dopóki konto nie jest aktywne.": "User cannot log in until account is active.",
        "Użytkownik usunięty z zespołu": "User removed from team",
        "Użytkownik z zespołu zostali dodani.": "User from team have been added.",
        "Użytkownik został dodany do zespołu.": "User has been added to team.",
        "Użytkownik został dodany.": "User has been added.",
        "Użytkownik został przypisany do szkolenia.": "User has been assigned to training.",
        "Użytkownik został przypisany do ścieżki szkoleniowej.": "User has been assigned to training path.",
        "Użytkownik został przypisany do terminu.": "User has been assigned to date.",
        "Użytkownik został usunięty.": "User has been deleted.",
        "Użytkownik został zablokowany, a jego wiadomości ukryte.": "User has been blocked, and their messages hidden.",
        "Użytkownik został zaktualizowany.": "User has been updated.",
        "Video": "Video",
        "W trakcie": "In progress",
        "W trakcie weryfikacji": "Under review",
        "w tym ": "including ",
        "Wartość 0 oznacza brak limitu": "Value 0 means no limit",
        "Wartość domyślna oznacza, że użytkownik może zaliczyć element od razu po odtworzeniu zasobu": "Default value means user can complete item immediately after resource playback",
        "Wartość nie może byc mniejsza niż 0": "Value cannot be less than 0",
        "Webinar": "Webinar",
        "Wersje": "Versions",
        "Wiadomości": "Messages",
        "Wiadomość": "Message",
        "Wiadomość została przywrócona.": "Message has been restored.",
        "Wiadomość została ukryta.": "Message has been hidden.",
        "Wideo": "Video",
        "Wideo z biblioteki": "Video from library",
        "Wideo zewnętrzne (URL)": "External video (URL)",
        "Wielokrotnego wyboru": "Multiple choice",
        "Witryna": "Website",
        "Właściwości": "Properties",
        "Włącz ankietę": "Enable survey",
        "Włącz chat": "Enable chat",
        "Włącz monitorowanie aktywności": "Enable activity tracking",
        "Włącz przyznawanie punktów": "Enable awarding points",
        "Włączenie cykliczności spowoduje usunięcie dat dostępu dla użytkowników i zespołów": "Enabling recurrence will delete access dates for users and teams",
        "Włączona": "Enabled",
        "Wpis został usunięty.": "Entry has been deleted.",
        "Wpis został zaktualizowany.": "Entry has been updated.",
        "Wprowadzenie zmian w polu \"Wybierz paczkę SCORM\" powoduje, że nadpisanie dotychczasowej wersji elementu szkolenia jest niedostępne.": "Making changes in \"Select SCORM package\" field makes overwriting current training item version unavailable.",
        "Wprowadzenie zmian w polu \"Źródło\" powoduje, że nadpisanie dotychczasowej wersji elementu szkolenia jest niedostępne.": "Making changes in \"Source\" field makes overwriting current training item version unavailable.",
        "Wprowadzenie zmian w zakładce \"ZAWARTOŚĆ\" powoduje, że nadpisanie dotychczasowej wersji elementu szkolenia jest niedostępne.": "Making changes in \"CONTENT\" tab makes overwriting current training item version unavailable.",
        "Wprowadzenie zmiany linku powoduje, że nadpisanie dotychczasowej wersji elementu szkolenia jest niedostępne.": "Changing link makes overwriting current training item version unavailable.",
        "wrzesień": "September",
        "wrześniu": "in September",
        "Wszyscy użytkownicy": "All users",
        "Wszystkie": "All",
        "Wszystkie kategorie": "All categories",
        "Wszystkie typy": "All types",
        "Wtorek": "Tuesday",
        "Wybieranie katalogu jest wymagane": "Selecting directory is required",
        "Wybierz": "Select",
        "Wybierz aktywność": "Select activity",
        "Wybierz ankietę do wypełnienia po szkoleniu": "Select survey to complete after training",
        "Wybierz ankietę do wypełnienia przed szkoleniem": "Select survey to complete before training",
        "Wybierz certyfikat": "Select certificate",
        "Wybierz długość generowanej treści.": "Select generated content length.",
        "Wybierz element": "Select item",
        "Wybierz katalog": "Select directory",
        "Wybierz kategorię": "Select category",
        "Wybierz paczkę": "Select package",
        "Wybierz paczkę SCORM": "Select SCORM package",
        "Wybierz rok: ": "Select year: ",
        "Wybierz stanowisko": "Select position",
        "Wybierz stronę": "Select page",
        "Wybierz strony": "Select pages",
        "Wybierz szkolenie": "Select training",
        "Wybierz szkolenie ze ścieżki szkoleniowej": "Select training from training path",
        "Wybierz temat": "Select topic",
        "Wybierz użytkownika": "Select user",
        "Wybierz wersję": "Select version",
        "Wybierz wydarzenie": "Select event",
        "Wybierz wydział": "Select department",
        "wybierz...": "select...",
        "Wybór kategorii": "Category selection",
        "Wybór listy stron": "Page list selection",
        "Wybór możliwy po zapisaniu zmian w teście.": "Selection possible after saving changes in test.",
        "Wybór strony przekierowującej": "Redirect page selection",
        "Wybrana wersja slajdu została wygenerowana w nieprawidłowym formacie. Nie można jej wyświetlić.": "Selected slide version was generated in invalid format. It cannot be displayed.",
        "Wybrane kategorie": "Selected categories",
        "Wybrane spotkanie nie jest opublikowane": "Selected meeting is not published",
        "Wybrane szkolenie nie jest opublikowane": "Selected training is not published",
        "Wybrane wydarzenie nie jest opublikowane": "Selected event is not published",
        "Wybrane wydarzenie nie ma włączonej opcji \"Wydarzenie dostępne tylko w module spotkań\"": "Selected event does not have \"Event available only in meetings module\" option enabled",
        "Wybranie ikony jest wymagane.": "Selecting icon is required.",
        "Wybranie katalogu jest wymagane": "Selecting directory is required",
        "Wybranie statusu jest wymagane.": "Selecting status is required.",
        "Wybranie strony jest wymagane": "Selecting page is required",
        "Wybrano %0 użytkowników.": "Selected %0 users.",
        "Wybrano jednego użytkownika.": "Selected one user.",
        "Wybrany certyfikat jest już nieaktualny.": "Selected certificate is already outdated.",
        "Wybrany materiał został już dodany do lekcji": "Selected material has already been added to lesson",
        "Wybrany materiał został już dodany do testu": "Selected material has already been added to test",
        "Wyczyść": "Clear",
        "Wydarzenie z kalendarza": "Calendar event",
        "Wydział": "Department",
        "Wydział został dodany.": "Department has been added.",
        "Wydział został usunięty.": "Department has been deleted.",
        "Wydziały": "Departments",
        "Wymagaj kolejności zaliczania elementów": "Require item completion order",
        "Wymagaj odpowiedzi, aby przejść dalej": "Require answer to continue",
        "Wymagaj pełnego odsłuchania do zaliczenia": "Require full listening to complete",
        "Wymagaj pełnego odsłuchania/obejrzenia do zaliczenia": "Require full listening/viewing to complete",
        "Wymagaj wszystkich warunków": "Require all conditions",
        "wymagany": "required",
        "Wymagany procent musi zawierać się w przedziale 0-100": "Required percentage must be between 0 and 100",
        "Wymuś nowe podejście - reset wyniku": "Force new attempt - reset result",
        "Wynik": "Result",
        "Wynik (%)": "Result (%)",
        "Wystapił błąd podczas kopiwaniu linku.": "An error occurred while copying link.",
        "Wystąpił błąd archiwizacji": "An error occurred during archiving",
        "Wystąpił błąd podczas próby exportu.": "An error occurred while trying to export.",
        "Wystąpił błąd podczas próby pobrania szczegółów.": "An error occurred while trying to download details.",
        "Wystąpił błąd podglądu": "Preview error occurred",
        "Wystąpił błąd. Nie udało się zmienić statusu.": "An error occurred. Status could not be changed.",
        "Wystąpił błąd. Spróbuj ponownie później.": "An error occurred. Please try again later.",
        "Wystąpił problem z pobraniem certyfikatu": "A problem occurred while downloading certificate",
        "Wystąpił problem z potwierdzeniem obecności": "A problem occurred while confirming attendance",
        "Wyszukaj": "Search",
        "Wyszukaj użytkownika": "Search user",
        "Wyszukaj zespół": "Search team",
        "Wyświetl materiały": "Display materials",
        "Wyświetl popup z kontynuacją lekcji": "Display popup with lesson continuation",
        "Wyświetlanie": "Display",
        "Wyżej": "Higher",
        "z maksymalnie 240 znaków": "up to 240 characters",
        "z maksymalnie 580 znaków": "up to 580 characters",
        "Zaakceptowane": "Approved",
        "Zaakceptowany": "Approved",
        "Zaawansowane": "Advanced",
        "Zablokowany": "Blocked",
        "Zablokuj użytkownika": "Block user",
        "zacznij pisać aby wyszukać certyfikat...": "start typing to search certificate...",
        "zacznij pisać aby wyszukać kategorię...": "start typing to search category...",
        "zacznij pisać aby wyszukać materiał...": "start typing to search material...",
        "zacznij pisać aby wyszukać paczkę SCORM...": "start typing to search SCORM package...",
        "zacznij pisać aby wyszukać spotkanie...": "start typing to search meeting...",
        "zacznij pisać aby wyszukać stanowisko...": "start typing to search position...",
        "zacznij pisać aby wyszukać szkolenie...": "start typing to search training...",
        "zacznij pisać aby wyszukać użytkownika...": "start typing to search user...",
        "zacznij pisać aby wyszukać wydarzenie...": "start typing to search event...",
        "zacznij pisać aby wyszukać wydział...": "start typing to search department...",
        "zacznij pisać aby wyszukać zespół...": "start typing to search team...",
        "zacznij pisać aby wyszukać...": "start typing to search...",
        "Zajawka": "Lead",
        "Zakończenie spotkania": "Meeting end",
        "Zakończenie szkolenia": "Training end",
        "Zakończenie zapisów": "Registration end",
        "Zakończony": "Completed",
        "Zakończyło": "Ended",
        "Zalecane wymiary 1605x450": "Recommended dimensions 1605x450",
        "Zaliczenie": "Completion",
        "Zaliczenie testu": "Test completion",
        "Zaliczenie testu jest równoznaczne z potwierdzeniem obecności i wystawieniem certyfikatu dla użytkownika": "Passing test is equivalent to confirming attendance and issuing certificate for user",
        "Zaliczone": "Completed",
        "Zaliczono wszystkie elementy szkolenia.": "All training items have been completed.",
        "Zaliczono wybrane elementy szkolenia.": "Selected training items have been completed.",
        "Zaliczony": "Completed",
        "Zamknij": "Close",
        "Zapis nowej wersji elementu szkolenia": "Save new training item version",
        "Zapis został usunięty": "Registration has been deleted",
        "Zapisani": "Registered",
        "Zapisz": "Save",
        "Zapisz i wróć": "Save and back",
        "Zapisz i wyślij": "Save and send",
        "Zapisz lekcję": "Save lesson",
        "Zapisz lekcję scorm": "Save SCORM lesson",
        "Zapisz lekcję scorm w nowej wersji": "Save SCORM lesson as new version",
        "Zapisz lekcję w nowej wersji": "Save lesson as new version",
        "Zapisz lekcję wideo": "Save video lesson",
        "Zapisz lekcję wideo w nowej wersji": "Save video lesson as new version",
        "Zapisz link": "Save link",
        "Zapisz link w nowej wersji": "Save link as new version",
        "Zapisz slajd": "Save slide",
        "Zapisz ścieżkę aby móc ją opublikować.": "Save path to be able to publish it.",
        "Zapisz temat": "Save topic",
        "Zapisz test": "Save test",
        "Zapisz test w nowej wersji": "Save test as new version",
        "Zarchiwizowane": "Archived",
        "Zarządzaj zespołami": "Manage teams",
        "Zarządzanie zespołami": "Team management",
        "Zawartość": "Content",
        "Zaznacz/odznacz wszystko": "Select/deselect all",
        "Zbliżająca się data zakończenia": "Upcoming end date",
        "Zespół": "Team",
        "Zespół aktywny": "Active team",
        "Zespół został dodany.": "Team has been added.",
        "Zespół został przypisany do szkolenia.": "Team has been assigned to training.",
        "Zespół został przypisany do ścieżki szkoleniowej.": "Team has been assigned to training path.",
        "Zespół został przypisany do terminu.": "Team has been assigned to date.",
        "Zespół został usunięty.": "Team has been deleted.",
        "Zespół został zaktualizowany.": "Team has been updated.",
        "Zewnętrzny link jest wymagany": "External link is required",
        "Zewnętrzny serwis": "External service",
        "Zielony": "Green",
        "Zmiana wersji elementu nie dotyczy użytkowników z zakończonym szkoleniem": "Changing item version does not apply to users with completed training",
        "Zmień status": "Change status",
        "Zmień widok": "Change view",
        "Zresetowano podejście.": "Attempt has been reset.",
        "zresetuj podejście do elementu szkolenia": "reset attempt for training item",
        "Zwrócony": "Returned",
        "Zwykłe": "Regular",
        "Źródło": "Source",
        "Żółty": "Yellow"
    }
};
